// removed by extract-text-webpack-plugin
module.exports = {"block":"MainMenuItem__block-_9WDQ","title":"MainMenuItem__title-1yYU4","badge":"MainMenuItem__badge-FVlTx","icon":"MainMenuItem__icon-1nAFF","image":"MainMenuItem__image-oJ2pI"};